import Button from "../Component/Elements/Button/Normal/Button";
import MainPage from "../Component/Elements/Page/MainPage/MainPage";
import Text from "../Component/Elements/Text/Text";

const TestPage = () => {
    return(
        <MainPage title="TEST PAGE">
            <Text>
                버튼 프리셋
            </Text>
            <Button
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                normal
            </Button>
            <Button
                preset={"cancel"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                cancel
            </Button>
            <Button
                preset={"delete"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                delete
            </Button>
            <Button
                preset={"save"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                save
            </Button>
            <Button
                preset={"edit"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                edit
            </Button>
            <Button
                preset={"agree"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                agree
            </Button>
            <Button
                onClick={(event) => {
                    event.stopPropagation();
                }}
                disabled
            >
                disabled
            </Button>
            <Button
                preset={"move_page"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                move_page
            </Button>
            <Button
                preset={"detail_modal"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                detail_modal
            </Button>
            <Button
                preset={"detail_view"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                detail_view
            </Button>
            <Button
                preset={"trashcan_icon_btn"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                trashcan_icon_btn
            </Button>
            <Button
                preset={"background_white"}
                onClick={(event) => {
                    event.stopPropagation();
                }}
            >
                background_white
            </Button>
        </MainPage>
    )
}

export default TestPage;